import axios from 'axios';
import Vue from 'vue'
export default {
    getOffers (active , page, pageSize, supplierId, before,after, isGroupedPromotions) {
        return axios.get('/api/offers/list', { params: {active:active, page: page, pageSize: pageSize , supplierId:supplierId, before:before , after:after, isGroupedPromotions} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getAllOffers (page, pageSize, supplierId) {
        return axios.get('/api/offers/all', { params: {page: page, pageSize: pageSize ,supplierId:supplierId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getPromotion (promotionId) {
        return axios.get('/api/offers/offer', { params: {promotionId:promotionId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getIsPreOrderSupplier () {
        return axios.get('/api/offers/is-pre-order')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getSuppliersOfferType () {
        return axios.get('/api/offers/suppliersOfferType')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveDetails(promotion){
        return axios.post('/api/offers/saveDetails', promotion)
        .then(response => {
            if (response && response.data){
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    deleteRule(rule,promotionID){
        return axios.post('/api/offers/deleteRule/'+promotionID, rule)
        .then(response => {
            if (response && response.data){
                Vue.prototype.$snotify.success("Palier supprimé avec succès");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    addRuleToOffer(rule,promotionID){
        return axios.post('/api/offers/addRule/'+promotionID, rule)
        .then(response => {
            if (response && response.data){
                Vue.prototype.$snotify.success("Palier ajouté avec succès");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    addItemToOffer(item,promotionID){
        return axios.post('/api/offers/addItem/'+promotionID, item)
        .then(response => {
            if (response && response.data){
                Vue.prototype.$snotify.success("Article ajouté avec succès");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    addItemGroupToOffer(item,promotionID){
        return axios.post('/api/offers/addItemGroup/'+promotionID, item)
        .then(response => {
            if (response && response.data){
                Vue.prototype.$snotify.success("Article ajouté avec succès");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    deleteItem(item,promotionID){
        return axios.post('/api/offers/deleteItem/'+promotionID, item)
        .then(response => {
            if (response && response.data){
                Vue.prototype.$snotify.success("Article supprimé avec succès");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },



    getSupplierItems(category){
        return axios.get('/api/offers/supplierItems', { params: {category:category} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getItems(category,promotionID){
        return axios.get('/api/offers/promotionItems/'+promotionID, { params: {category:category} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveDescription(promotion){
        return axios.post('/api/offers/saveDescription', promotion)
        .then(response => {
            if (response && response.data){
                return response.data;
            } 
            
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    changeActivation(promotion){
        return axios.post('/api/offers/change/activation', promotion)
        .then(response => {
            if (response && response.data){
                return response.data;
            }

            //For the case when the supplier is trying to activate an non applicable offer so he has to be redirected to Inactive offers tab not to Active offers tab
            if(response.data === false) {
                return response.data;
            }
            
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getTopSupplierOffers(page,pageSize){
        return axios.get('/api/offers/topSupplierlist', { params: {page: page, pageSize: pageSize} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    deleteOffer(promotionDTO){
        return axios.post('/api/offers/delete/promotion/', promotionDTO)
        .then(response => {
            if (response && response.data){
                Vue.prototype.$snotify.success("Offre supprimé avec succès");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getActiveCustomersWithFilter (filter, promotionId, page, pageSize) {
        return axios.get('/api/offers/customers/list', { params: {  filter: filter, promotionId:promotionId, page: page, pageSize: pageSize} })
        .then(customersListDTO => {
            if (customersListDTO && customersListDTO.data) return customersListDTO.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    
    editSelection (selectedCustomers,promotionId) {
        return axios.post('/api/offers/editTradersClients', {list : selectedCustomers, promotionId:promotionId}  )
        .then(response => {
            if (response && response.data){
                //Vue.prototype.$snotify.success("La liste des clients a été mise à jour");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    removeAllCustomers(promotionId) {
        return axios.post('/api/offers/remove-all-customers', {promotionId:promotionId}  )
        .then(response => {
            if (response && response.data){
                //Vue.prototype.$snotify.success("La liste des clients a été mise à jour");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getCustomersInPromotion (promotionId) {
        return axios.get('/api/offers/customers-in-promotion', { params: {  promotionId:promotionId} })
        .then(customersListDTO => {
            if (customersListDTO && customersListDTO.data) return customersListDTO.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    sendMail (promotionId) {
        return axios.get('/api/offers/send-mail', { params: {  promotionId:promotionId} })
        .then(response => {
            if (response && response.data){
                Vue.prototype.$snotify.success("L'envoi des emails est planifié");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
}